export default __webpack_public_path__ + "static/media/svn.a33b68ed.png";